// -----------------------------------------------------------------------------
// BuildNexx logo (v0.9.2 — "Idea 2 · App Colours · R3", approved by Kyle 04/Nov/26 on the logo canvas).
//
//   BrandMark      the icon: rounded terracotta square, a dark first chevron and a white second one. Drawn INLINE as SVG
//                  (no image request, sharp at any size). size = px (26 sidebar, 40 sign-in pages).
//                  Next to the visible word "BuildNexx" it is decorative (aria-hidden); shown alone (collapsed sidebar)
//                  pass `label` so screen readers hear "BuildNexx".
//   BrandWordmark  "Build" in ink + "Nexx" in the accent colour, font Outfit 700 (loaded in public/index.html).
//
// Used by: core/layout/Shell.tsx (sidebar .brand and collapsed .brand.mini), core/pages/LoginPage.tsx and
// core/pages/AuthPages.tsx (.brand.big). Styles: .brand / .brand-word / .brand-nexx in public/styles.css.
// ONE source of truth for the colours: BRAND below. public/favicon.svg must use the same three colours —
// tests/unit/brand.test.tsx fails when one changes without the other; it also checks the icon links in index.html.
// Boards draw the same icon (boards/gen_app.py BRAND_SVG); the email header uses public/icons/icon-192.png.
// -----------------------------------------------------------------------------

export const BRAND = { bg: "#B9481F", ink: "#712B13", light: "#FFFFFF" } as const;

export function BrandMark({ size = 26, label }: { size?: number; label?: string }) {
  const a11y = label ? { role: "img", "aria-label": label } : { "aria-hidden": true as const };
  return (
    <svg className="brand-mark" width={size} height={size} viewBox="0 0 100 100" focusable="false" {...a11y}>
      <rect width="100" height="100" rx="22" fill={BRAND.bg} />
      <path d="M27 28 L49 50 L27 72" stroke={BRAND.ink} strokeWidth="11" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M51 28 L73 50 L51 72" stroke={BRAND.light} strokeWidth="11" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export const BrandWordmark = () => <span className="brand-word">Build<span className="brand-nexx">Nexx</span></span>;
